// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";

// 引入element-ui
import ElementUI from "element-ui";
import "../static/ele-theme/index.css";
import locale from "../static/element-lang/zh-CN";
import "./style/app.less";
Vue.use(ElementUI, { locale });
// 路由配置项
import router from "./router";

import service from "./service";
Vue.prototype.service = service;

import dateUtils from "./utils/date.js";
Vue.prototype.$date = dateUtils;
import checkPermission from "./utils/checkPermission.js";
Vue.prototype.$checkPermission = checkPermission;

import common from "./common";
Vue.prototype.common = common;

import webData2Excel from "webData2Excel";
Vue.prototype.webData2Excel = webData2Excel;

import filter from "./filter";
for (let key in filter) {
  Vue.filter(key, filter[key]);
}

Vue.config.productionTip = false;

// 引入裁剪图片
import VueCropper from "vue-cropper";
Vue.use(VueCropper);

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js